// extracted by mini-css-extract-plugin
module.exports = {"section":"Section_section__NEjKS","titleContainer":"Section_titleContainer__2VF93","highlight":"Section_highlight__15MNc","noHighlight":"Section_noHighlight__yekzb"};